import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectTriggerOverview, CommonProjectTriggerTopics } from "../../CommonComponents/CommonProjectTriggerViews";
export const ProjectDeploymentTargetTriggerRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().deploymentTargetTrigger,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectTriggerOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectTriggerTopics />;
    },
};
